import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetch";

/**
 * This is a utility type to help infer types in custom hooks
 */
export type UseFetchResult<T, K extends string> = Omit<UseQueryResult<T>, "data"> & {
  [P in K]: T;
};

// For GET requests
export function useFetch<T>({ url, queryKey }: { url: string; queryKey: readonly string[] }) {
  return useQuery<T>({
    queryKey,
    queryFn: () => fetcher<T>(url),
    enabled: !!url,
  });
}
